export const BASE_URL = 'http://admin.dgentreprises.biz/'
export const NOTIFICATION_URL = 'api_form/nav_barre.php'
export const SIDE_NAV_URL = 'api/api_interface/menu'